import type { TFunction } from "i18next";

/** Backend'in döndüğü error mesajı anahtarlarını i18n'e çevirir.
 *  Backend 400/409'da response.data.message olarak belirli anahtarlar döner;
 *  bunları kullanıcıya anlaşılır metne dönüştürür.
 */
const KNOWN_KEYS = new Set([
  "INTERN_SUB_CATEGORY_INVALID_FOR_TYPE",
  "INTERN_LISE_PARENT_INFO_REQUIRED",
  "INTERN_LISE_COORDINATOR_INFO_REQUIRED",
  "INTERN_NOT_IN_SCOPE",
  "INTERN_CERTIFICATE_NOT_AVAILABLE",
]);

interface AxiosLikeError {
  response?: {
    data?: { message?: unknown };
  };
  message?: string;
}

export function extractBackendMessage(err: unknown): string | undefined {
  const e = err as AxiosLikeError;
  const msg = e?.response?.data?.message;
  if (typeof msg === "string") return msg;
  if (Array.isArray(msg) && typeof msg[0] === "string") return msg[0];
  return undefined;
}

export function translateInternApiError(
  err: unknown,
  t: TFunction,
  fallback: string,
): string {
  const raw = extractBackendMessage(err);
  if (raw && KNOWN_KEYS.has(raw)) {
    return t(`internManagement.errorMessages.${raw}`, fallback);
  }
  return raw || fallback;
}
